// extracted by mini-css-extract-plugin
export default {"title":"Header_title__fyz0d","subTitleBlock":"Header_subTitleBlock__MRH3E","subTitle":"Header_subTitle__fQYnm"};